var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79738 0.0755665C9.89779 0.141771 9.96749 0.244707 9.99116 0.361731C10.0148 0.478755 9.99052 0.600284 9.92359 0.699587L4.46283 8.79985C4.42546 8.8552 4.37615 8.90166 4.31844 8.93589C4.26073 8.97013 4.19606 8.99128 4.12909 8.99782C4.06212 9.00436 3.99452 8.99613 3.93115 8.97373C3.86779 8.95132 3.81023 8.9153 3.76264 8.86825L0.122134 5.26814C0.0417516 5.18283 -0.00200918 5.07 7.0897e-05 4.95341C0.00215097 4.83683 0.0499095 4.72559 0.133285 4.64314C0.21666 4.56069 0.329143 4.51346 0.447035 4.51141C0.564928 4.50935 0.679025 4.55262 0.76529 4.63211L4.01323 7.84402L9.16636 0.200371C9.23331 0.101076 9.3374 0.0321457 9.45574 0.00874081C9.57407 -0.0146641 9.69697 0.0093735 9.79738 0.0755665Z",
    fill: "#7D8FB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d0d6b2d312eb7eae704aa6f1b778b1b2.svg";
export { ForwardRef as ReactComponent };